module.exports = __webpack_public_path__ + "static/media/BuilderBanner.e2808094.svg";